interface IDetailServiceObservationProps {
  observation: string;
}

const DetailServiceObservation = (props: IDetailServiceObservationProps) => {
  return (
    <div className="mb-4">
      <div className="font-bold mb-2 text-size-12 text-gray-500 dark:text-neutral-400">Observação</div>
      <div className="text-size-14 bg-white dark:bg-neutral-800 p-3 rounded border border-gray-200 dark:border-neutral-700">
        {props.observation}
      </div>
    </div>
  );
};

export default DetailServiceObservation;

